import React from "react";

const XbuttonGrowth = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="15.8975"
        y="1.1748"
        width="20.8209"
        height="1.66182"
        rx="0.830909"
        transform="rotate(135 15.8975 1.1748)"
        fill="#19787B"
      />
      <rect
        x="1.17529"
        width="20.8209"
        height="1.66182"
        rx="0.830909"
        transform="rotate(45 1.17529 0)"
        fill="#19787B"
      />
    </svg>
  );
};

export default XbuttonGrowth;
